let firstStepBack = document.querySelector('.step__one .back a');
let subscriptionProducts = document.querySelectorAll('.subscription.first-step .product__item');
let url = window.location.pathname.split('/')[2];
const checkout = document.querySelector('.subscription.third-step .button-container button');

let productVariants

let rightEye
let rightSelect

let leftEye
let leftSelect

let rightPopup
let leftPopup

let question
let questionState
let continueButton
let helpContainer
let productInner

if(document.querySelector('.subscription.first-step')) {
    const helpPopupBtn = document.querySelector('.help__popup-btn a');
    const helpPopup = document.querySelector('.help__popup');
    const helpPopupInner = document.querySelector('.help__popup-inner');

    const closePopup = function (evt) {
        let pointer = evt.target;
        if (
            pointer.closest('.closePopup') ||
            !pointer.closest('.help__popup-inner')
        ) {
            if (!helpPopup.classList.contains('close')) {
                helpPopup.classList.add('close');
                body.style = 'overflow: auto;';
                helpPopup.removeEventListener('click', closePopup);
                // window.removeEventListener("click", closePopup)
            }
        }
    };

    helpPopupBtn.addEventListener('click', function () {
        if (helpPopup.classList.contains('close')) {
            helpPopup.classList.remove('close');
            body.style = 'overflow: hidden;';
            helpPopup.addEventListener('click', closePopup);
        }
    });

//********** select **********//
    const helpPopupSelect = document.querySelector('.help__popup-select');
    const helpPopupList = document.querySelector('.help__popup-list');

    helpPopupSelect.addEventListener('click', function () {
        helpPopupList.classList.toggle('close');
        helpPopupSelect.classList.toggle('active');
    });

    const createInfo = function (pointer) {
        let text = document.createElement('p');
        text.classList.add('main-text', 'center', 'item__text');
        text.textContent = pointer.dataset.text;
        helpPopupSelect.textContent = pointer.textContent;
        helpPopupInner.appendChild(text);
        let linkSplit = pointer.dataset.product.split('products/');

        let link = document.createElement('a');
        link.classList.add('item__link', 'center', 'btn__primary');
        link.href = pointer.dataset.product;
        link.textContent = "VIEW " + (linkSplit[linkSplit.length - 1].toUpperCase()).replaceAll('-', ' ').replaceAll(' 1MONTH', '');
        helpPopupInner.appendChild(link);

        helpPopupList.classList.add('close');
        helpPopupSelect.classList.remove('active');
    };

    const helpPopupItems = document.querySelectorAll('.help__popup-item');

    const deleteActive = function () {
        helpPopupItems.forEach(function (item, i, arr) {
            if (item.classList.contains('active')) {
                item.classList.remove('active');
            }
        });
    };

    helpPopupList.addEventListener('click', function (evt) {
        let pointer = evt.target;
        if (pointer.classList.contains('help__popup-item')) {
            const itemText = helpPopup.querySelector('.item__text');
            const itemLink = helpPopup.querySelector('.item__link');
            if (itemText && itemLink) {
                itemText.remove();
                itemLink.remove();
            }
            createInfo(pointer);
            deleteActive();
            pointer.classList.add('active');
        }
    });
}

if(subscriptionProducts) {
    for (let i = 0; i < subscriptionProducts.length; i++) {
        subscriptionProducts[i].addEventListener('click', function () {
            let handle = subscriptionProducts[i].getAttribute('data-product-handle');
            firstStepBack.setAttribute('href', `/products/${handle}`)
        })
    }
}

function getSetId(){
    let set;
    set = Date.now().toString();
    set = set.slice(4);
    let number = Math.floor(Math.random() * 9000 + 1000);
    set = number.toString() + set;
    return set;
}


let cartCount = 0;
fetch('/cart.js')
    .then((response) => {
        return response.json()
    })
    .then((response) => {
        if(response.item_count > 0){
            cartCount = response.item_count;
        }
    })

function stepJs(){
    let nextButton = document.querySelector('.step-btn');
    let cartPopup = document.querySelector('.cart-alert-popup');
    let cartPopupOverlay = document.querySelector('.cart-alert-popup-overlay')
    if(cartCount > 0){
        nextButton.querySelector('a').removeAttribute("href");
        nextButton.addEventListener('click',function(){
            cartPopup.classList.add('active');
            cartPopupOverlay.classList.remove('hidden');
            document.body.style.overflow = "hidden";
        })
        let cartPopupClose = cartPopup.querySelector('.close-button');
        cartPopupClose.addEventListener('click',function(){
            cartPopup.classList.remove('active');
            cartPopupOverlay.classList.add('hidden');
            document.body.removeAttribute("style");
        })
    }

    //first step
    // If this URL
    if(url === 'select-your-lens-type'){
        //Create variable
        let selectedProduct
        //If the product in local storage isn't set
        if(!localStorage.product) {
            // Set it to the product handle
            selectedProduct = subscriptionProducts[0].dataset.productHandle;
            // Put it in local storage e.g. daysoft-silk-1month
            localStorage.setItem('product', selectedProduct);
        }
        else{
            // On the first steps back button, set the href to be the handle of the product to go back to
            firstStepBack.setAttribute('href',`/products/${localStorage.product}`);
            // Loop through the subscritpion products (both 1 month products) and see if the attribute is the same as the local storage
            for(let i = 0; i < subscriptionProducts.length; i++){
                if(subscriptionProducts[i].getAttribute('data-product-handle') === localStorage.product) {
                    // Add an active class on the div
                    subscriptionProducts[i].classList.add('active');
                }
                else {
                    // If it's not the same then remove the active
                    subscriptionProducts[i].classList.remove('active');
                }
            }
        }

        // Loop through the subscritpion products (both 1 month products)
        for(let i = 0; i < subscriptionProducts.length; i++){
            // Add a click event listener to both of these
            subscriptionProducts[i].addEventListener('click',function(event){
                // Get the data attribute handle
                selectedProduct = subscriptionProducts[i].dataset.productHandle;
                // If the local storage product item is not equal to the above
                if(localStorage.product && localStorage.product !== selectedProduct){
                    // Remove everything out of session storage for variant IDs and values
                    sessionStorage.removeItem('leftVariantId');
                    sessionStorage.removeItem('leftVariantVal');
                    sessionStorage.removeItem('rightVariantId');
                    sessionStorage.removeItem('rightVariantVal');
                }
                // Set the local storage product item to be the one we've clicked on
                localStorage.setItem('product',selectedProduct);
                //GA Call for choosing which product on step 1
                window.GAUtil.selectLensType();
                // Also set the first step back button to be the handle of the product we've selected
                firstStepBack.setAttribute('href',`/products/${selectedProduct}`);
            });
        }
    }

    //second step
    // If this URL 
    if(url === 'select-your-lens-power'){
        // Set both variables to false
        let selectedLeft = false;
        let selectedRight = false;
        // Get div of the variants-container parent
        productVariants = document.querySelector('.product__variants');

        // Get the div right eye
        rightEye = document.querySelector('.rightEye');
        // Get the div of the select box for the right eye
        rightSelect = rightEye.querySelector('.variant__select');

        // Get the div right eye
        leftEye = document.querySelector('.leftEye');
        // Get the div of the select box for the right eye
        leftSelect = leftEye.querySelector('.variant__select');

        // If the product variable in the local storage is silk
        if(localStorage.product === 'daysoft-silk-1month'){
            //Get the right and left variant pop ups for silk
            rightPopup = document.querySelector('.right__popup.silk');
            leftPopup = document.querySelector('.left__popup.silk');
        }
        // If the product variable in the local storage is classic
        else if(localStorage.product === 'daysoft-classic-1month'){
            //Get the right and left variant pop ups for classic
            rightPopup = document.querySelector('.right__popup.classic');
            leftPopup = document.querySelector('.left__popup.classic');
        }


        // This section is for when the powers don't match and if the user is sure that this is correct or whether they want to change them
        question = document.querySelector('.question');
        questionState = document.querySelector('.question__state');
        continueButton = document.querySelector('.subscription.second-step .button-container');
        helpContainer = document.querySelector('.subscription.second-step .product-help-container');
        productInner = document.querySelector('.subscription.second-step .product__inner');

        const createQuestion = function () {
            question.classList.remove('hidden');
            questionState.classList.add('state__enable');
            if(continueButton){
                continueButton.classList.add('hidden');
            }
            if(helpContainer){
                helpContainer.classList.add('hidden');
            }
            if(productInner){
                productInner.classList.add('difference')
            }
        };

        const closeQuestion = function () {
            question.classList.add('hidden');
            questionState.classList.remove('state__enable')
        };

        const resetSelect = function (select, block) {
            select.textContent = 'Select';
            select.dataset.val = 0;
            if (block.classList.contains('diff')) {
                block.classList.remove('diff');
            }
            selectedLeft = false;
            selectedRight = false;
        };

        if(question) {
            question.addEventListener('click', function (evt) {
                let pointer = evt.target;
                if (pointer.closest('.btn__yes')) {
                    // closeQuestion();
                    // productInner.classList.remove('difference')
                    // helpContainer.classList.remove('hidden');
                    // continueButton.classList.remove('hidden');
                    // continueButton.querySelector('.button').classList.remove('disabled');
                } else if (pointer.closest('.btn__no')) {
                    sessionStorage.removeItem('leftVariantId');
                    sessionStorage.removeItem('leftVariantVal');
                    sessionStorage.removeItem('rightVariantId');
                    sessionStorage.removeItem('rightVariantVal');
                    productInner.classList.remove('difference')
                    helpContainer.classList.remove('hidden');
                    continueButton.classList.remove('hidden');
                    continueButton.querySelector('.button').classList.add('disabled');
                    closeQuestion();
                    resetSelect(rightSelect, rightEye);
                    resetSelect(leftSelect, leftEye);
                    window.GAUtil.resetLensSelection();
                }
            });
        }

        // Compare the two variant powers
        const compareVal = function () {

            // Get the value out of the data attribute
            var rightStrength = rightSelect.dataset.val;
            // Get the symbol at the start of the lens power either - or +
            var signRightStrength = rightStrength.charAt(0);
            // Turn into a float
            rightStrength = parseFloat(rightStrength.substring(1));

            // If the lens power is negative
            if(signRightStrength === "-"){
                // Turn it into a positive number
                rightStrength = rightStrength * -1;
            }


            // Do the same for the left lens power
            var leftStrength = leftSelect.dataset.val;
            var signleftStrength = leftStrength.charAt(0);
            leftStrength = parseFloat(leftStrength.substring(1));

            if(signleftStrength === "-"){
                leftStrength = leftStrength * -1;
            }


            // Create empty variable
            var differenceInStrength;
            // If the left lens power is stronger than the right lens power
            if(leftStrength > rightStrength){
                // Set the empty variable to the left lens power minus the right lens power
                differenceInStrength = leftStrength - rightStrength;
            } else {
                // Set the empty variable to the right lens power minus the left lens power
                differenceInStrength = rightStrength - leftStrength;
            }


            // If the difference between the two values is 3 or greater - show error message
            if (differenceInStrength > 3) {
                rightEye.classList.add('diff');
                leftEye.classList.add('diff');
                createQuestion();
            }
            // If one value is a positive and one value is a negative - show error message
            else if ((signRightStrength === "-" && signleftStrength === "+") || (signRightStrength === "+" && signleftStrength === "-")) {
                rightEye.classList.add('diff');
                leftEye.classList.add('diff');
                createQuestion();
            }
            // If neither of these two conditions - don't show error message
            else {
                productInner.classList.remove('difference')
                helpContainer.classList.remove('hidden');
                continueButton.classList.remove('hidden');
                rightEye.classList.remove('diff');
                leftEye.classList.remove('diff');
                closeQuestion();
                continueButton.querySelector('.button').classList.remove('disabled');
            }
        };

//********** RIGHT **********//

        const hiddenRight = function (evt) {
            let pointer = evt.target;
            if (pointer.closest('.closePopup') || !pointer.closest('.popup-inner')) {
                if (!rightPopup.classList.contains('close')) {
                    rightPopup.classList.add('close');
                    body.style = 'overflow: auto;';
                    rightPopup.removeEventListener('click', selectRight);
                    rightPopup.removeEventListener('click', hiddenRight);
                }
            }
        };

        const selectRight = function (evt) {
            let pointer = evt.target;
            if (pointer.closest('.variant')) {
                // Set variable to true
                selectedRight = true;
                rightSelect.textContent = pointer.textContent;
                //rightSelect.dataset.id = pointer.dataset.id;
                rightSelect.dataset.val = pointer.textContent;
                //sessionStorage.setItem('rightVariantId', pointer.dataset.id);
                sessionStorage.setItem('rightVariantVal', pointer.textContent);
                window.GAUtil.selectRightLensPower();

                if (selectedLeft === true) {
                    compareVal();
                }

                rightPopup.classList.add('close');
                body.style = 'overflow: auto;';
                rightPopup.removeEventListener('click', selectRight);
                rightPopup.removeEventListener('click', hiddenRight);
            }
        };

        if(document.querySelector('.product__variant.rightEye').dataset.power) {
            const power = document.querySelector('.product__variant.rightEye').dataset.power.trim().split(' /')[0];
            const powerId = document.querySelector('.right__popup .variant[data-product-variant-value="' + power + '"]').dataset.id;
            selectedRight = true;
            rightSelect.textContent = power;
            rightSelect.dataset.id = powerId;
            rightSelect.dataset.val = power;
            sessionStorage.setItem('rightVariantId', powerId);
            sessionStorage.setItem('rightVariantVal', power);

            if (selectedLeft === true) {
                compareVal();
            }
        }

//********** LEFT **********//

        const hiddenLeft = function (evt) {
            let pointer = evt.target;
            if (pointer.closest('.closePopup') || !pointer.closest('.popup-inner')) {
                if (!leftPopup.classList.contains('close')) {
                    leftPopup.classList.add('close');
                    body.style = 'overflow: auto;';
                    leftPopup.removeEventListener('click', selectLeft);
                    leftPopup.removeEventListener('click', hiddenLeft);
                    // window.removeEventListener("click", closePopup)
                }
            }
        };

        const selectLeft = function (evt) {
            let pointer = evt.target;
            if (pointer.closest('.variant')) {
                selectedLeft = true;
                leftSelect.textContent = pointer.textContent;
                //leftSelect.dataset.id = pointer.dataset.id;
                leftSelect.dataset.val = pointer.textContent;
                //sessionStorage.setItem('leftVariantId', pointer.dataset.id);
                sessionStorage.setItem('leftVariantVal', pointer.textContent);
                window.GAUtil.selectLeftLensPower();

                if (selectedRight === true) {
                    compareVal();
                }

                leftPopup.classList.add('close');
                body.style = 'overflow: auto;';
                leftPopup.removeEventListener('click', selectLeft);
                leftPopup.removeEventListener('click', hiddenLeft);
            }
        };

        if(document.querySelector('.product__variant.leftEye').dataset.power) {
            const power = document.querySelector('.product__variant.leftEye').dataset.power.trim().split(' /')[0];
            const powerId = document.querySelector('.left__popup .variant[data-product-variant-value="' + power + '"]').dataset.id;
            selectedLeft = true;
            leftSelect.textContent = power;
            leftSelect.dataset.id = powerId;
            leftSelect.dataset.val = power;
            sessionStorage.setItem('leftVariantId', powerId);
            sessionStorage.setItem('leftVariantVal', power);

            if (selectedRight === true) {
                compareVal();
            }
        }

        if(productVariants) {
            productVariants.addEventListener('click', function (evt) {
                let pointer = evt.target;
                if (pointer.closest('.rightEye')) {
                    if (pointer.closest('.variant__select') || pointer.closest('.icon')) {
                        rightPopup.classList.remove('close');
                        body.style = 'overflow: hidden;';
                        rightPopup.addEventListener('click', selectRight);
                        rightPopup.addEventListener('click', hiddenRight);
                    }
                } else if (pointer.closest('.leftEye')) {
                    if (pointer.closest('.variant__select') || pointer.closest('.icon')) {
                        leftPopup.classList.remove('close');
                        body.style = 'overflow: hidden;';
                        leftPopup.addEventListener('click', selectLeft);
                        leftPopup.addEventListener('click', hiddenLeft);
                    }
                }
            });
        }
        let popups = document.querySelectorAll('.variants__popup');
        if(localStorage.product === 'daysoft-silk-1month'){
            if(popups.length > 2) {
                popups[2].remove();
                popups[3].remove();
            }
        }
        else if(localStorage.product === 'daysoft-classic-1month'){
            if(popups.length > 2) {
                popups[0].remove();
                popups[1].remove();
            }
        }
        else{
            window.location.replace("select-your-lens-type");
        }
        if(sessionStorage.leftVariantVal){
            leftSelect.textContent = sessionStorage.leftVariantVal;
            //leftSelect.dataset.id = sessionStorage.leftVariantId;
            leftSelect.dataset.val = sessionStorage.leftVariantVal;
            selectedLeft = true;

        }
        if(sessionStorage.rightVariantVal){
            rightSelect.textContent = sessionStorage.rightVariantVal;
            //rightSelect.dataset.id = sessionStorage.rightVariantId;
            rightSelect.dataset.val = sessionStorage.rightVariantVal;
            selectedRight = true;
        }
        if(sessionStorage.leftVariantVal && sessionStorage.rightVariantVal){
            compareVal();
        }
    }

    //third step
    if(url === 'choose-your-subscription-terms'){
        console.trace();
        function createSelect(){
            let x, p, j, l, ll, selElmnt, a, b, c;
            // Get the frequency select boxes - outer div not the select
            x = document.getElementsByClassName("frequency");
            // Get how many there are - 3
            l = x.length;
            // Loop through them
            for (p = 0; p < l; p++) {
                // Get the actual select element and not the div
                selElmnt = x[p].getElementsByTagName("select")[0];
                // Get the length - 3
                ll = selElmnt.length;
                /* For each element, create a new DIV that will act as the selected item: */
                a = document.createElement("DIV");
                a.setAttribute("class", "select-selected");
                a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
                // Append a div with the selected item the user has chosen
                x[p].appendChild(a);
                /* For each element, create a new DIV that will contain the option list: */
                b = document.createElement("DIV");
                // This is for the dropdown list
                b.setAttribute("class", "select-items select-hide");
                for (j = 0; j < ll; j++) {
                    /* For each option in the original select element,
                    create a new DIV that will act as an option item: */
                    c = document.createElement("DIV");
                    c.innerHTML = selElmnt.options[j].innerHTML;
                    // If the index is the same as the selected options index
                    if(j === selElmnt.selectedIndex){
                        // Add this class to it
                        c.classList.add('same-as-selected');
                    }
                    c.addEventListener("click", function(e) {
                        /* When an item is clicked, update the original select box,
                        and the selected item: */
                        let y, p, k, s, h, sl, yl;
                        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                        // s.value = s.options[c.dataset.index].value;
                        // sessionStorage.setItem('freq',s.options[c.dataset.index].value);
                        sl = s.length;
                        h = this.parentNode.previousSibling;
                        for (p = 0; p < sl; p++) {
                            if (s.options[p].innerHTML == this.innerHTML) {
                                s.value = s.options[p].value;
                                // Set the sessions storage frequency to the one the user has selected
                                sessionStorage.setItem('freq',s.value);
                                s.selectedIndex = p;
                                h.innerHTML = this.innerHTML;
                                y = this.parentNode.getElementsByClassName("same-as-selected");
                                yl = y.length;
                                for (k = 0; k < yl; k++) {
                                    //When selecting another option remove the attribute from the previous option
                                    y[k].removeAttribute("class");
                                }
                                // Set the new options class to same-as-selected
                                this.setAttribute("class", "same-as-selected");
                                break;
                            }
                        }
                        h.click();
                    });
                    b.appendChild(c);
                }
                x[p].appendChild(b);
                a.addEventListener("click", function(e) {
                    /* When the select box is clicked, close any other select boxes,
                    and open/close the current select box: */
                    e.stopPropagation();
                    closeAllSelect(this);
                    this.nextSibling.classList.toggle("select-hide");
                    this.classList.toggle("select-arrow-active");
                });
            }
        }
        function closeAllSelect(elmnt) {
            /* A function that will close all select boxes in the document,
            except the current select box: */
            let x, y, p, xl, yl, arrNo = [];
            x = document.getElementsByClassName("select-items");
            y = document.getElementsByClassName("select-selected");
            xl = x.length;
            yl = y.length;
            for (p = 0; p < yl; p++) {
                if (elmnt == y[p]) {
                    arrNo.push(p)
                } else {
                    y[p].classList.remove("select-arrow-active");
                }
            }
            for (p = 0; p < xl; p++) {
                if (arrNo.indexOf(p)) {
                    x[p].classList.add("select-hide");
                }
            }
        }

        document.addEventListener("click", closeAllSelect);
        //Create select boxes on dom content loaded
        document.addEventListener('DOMContentLoaded',createSelect);

        // If the product is silk
        if(localStorage.product === 'daysoft-silk-1month'){
            // Get the prices div for the silks
            const silks = document.querySelectorAll('.box-price.box-silk');
            // Get the toal prices div for the silks
            const totalSilks = document.querySelectorAll('.total-silk');
            for(let i = 0; i < silks.length; i++){
                // Loop through all of them and remove the hidden class to show the silk prices
                silks[i].classList.remove('hidden');
                totalSilks[i].classList.remove('hidden');
            }
        }
        // Else if the product is classic
        else if(localStorage.product === 'daysoft-classic-1month'){
            // Get the prices div for the classic
            const classics = document.querySelectorAll('.box-price.box-classic');
            // Get the toal prices div for the classic
            const totalClassics = document.querySelectorAll('.total-classic');
            for(let i = 0; i < classics.length; i++){
                // Loop through all of them and remove the hidden class to show the classic prices
                classics[i].classList.remove('hidden');
                totalClassics[i].classList.remove('hidden');
            }
        }
        let prevBox;
        // If none of variant values are set in session storage then go back to previous page - step 2
        if(!sessionStorage.leftVariantVal || !sessionStorage.rightVariantVal){
            window.location.replace("select-your-lens-power");
        }
        // If the product storage item isn't set go back to step 1
        if(!localStorage.product){
            window.location.replace("select-your-lens-type");
        }
        // The product divs
        let boxes = document.querySelectorAll('.subscription.third-step .product__item');
        let freqs = document.querySelectorAll('.subscription.third-step .select-frequency');
        if(!sessionStorage.freq){
            // If the frequency session storage doesnt exist then set it
            sessionStorage.setItem('freq',freqs[0].value);
            
        }
        if(!sessionStorage.pairs){
            // If the session storage of pairs isn't set then set it for both session and local
            sessionStorage.setItem('pairs',boxes[0].dataset.productPairs);
            localStorage.setItem('pairs',boxes[0].dataset.productPairs);
            //Set the variable to the first one in the list
            prevBox = boxes[0];
        }
        //If the session storage pairs is set
        else if(sessionStorage.pairs){
            // Fill in the attributes
            prevBox = document.querySelector(`.subscription.third-step .product__item[data-product-pairs="${sessionStorage.pairs}"]`).dataset.productPairs;
            // Go through all the different boxes
            for(let i = 0; i < boxes.length; i++){
                // If the data attribute of one of the boxes is equal to whats in the session storage
                if(boxes[i].dataset.productPairs === sessionStorage.pairs){
                    // Then add an active class onto it
                    boxes[i].classList.add('active');
                    // If the sesssion storage frequency is set
                    if(sessionStorage.freq){
                        // Set the selected value in the frequency dropdown to be the same
                        boxes[i].querySelector('.select-frequency').value = sessionStorage.freq;
                    }
                }
                // If none of this is true then remove the active class
                else{
                    boxes[i].classList.remove('active');
                }
            }
        }
        // Go through all the different products/box
        for(let i = 0; i < boxes.length; i++){
                boxes[0].click();
            // Add a click listener on each
            boxes[i].addEventListener('click',function(e){
                // Once clicked set the session and local storage to the pairs either 32, 96 or 192
                sessionStorage.setItem('pairs', boxes[i].dataset.productPairs);
                localStorage.setItem('pairs', boxes[i].dataset.productPairs);
                if (typeof window.GAUtil.selectSubscriptionPlan !== 'undefined') {
                    window.GAUtil.selectSubscriptionPlan();
                }

                // If the product is silk
                if(localStorage.product === 'daysoft-silk-1month'){
                    // Set a local and session storage item to the one thats been clicked out of the 3 for silk - data attribute
                    localStorage.setItem('productID', boxes[i].dataset.silkProductid);
                    sessionStorage.setItem('productID', boxes[i].dataset.silkProductid);
                    sessionStorage.setItem('productHandle', boxes[i].dataset.silkHandle);
                    // else if the product is classic
                } else if(localStorage.product === 'daysoft-classic-1month'){
                    // Set a local and session storage item to the one thats been clicked out of the 3 for classic - data attribute
                    localStorage.setItem('productID', boxes[i].dataset.classicProductid);
                    sessionStorage.setItem('productID', boxes[i].dataset.classicProductid);
                    sessionStorage.setItem('productHandle', boxes[i].dataset.classicHandle);
                }

                // If the variable isn't set to one of the products/boxes
                if(prevBox !== boxes[i]) {
                    //Set the session storage to the selected value of the frequency select
                    sessionStorage.setItem('freq', boxes[i].querySelector('.select-frequency').value || boxes[i].querySelector('.select-frequency option').value)
                }
                //Set it to the one thats been clicked
                prevBox = boxes[i];
            })
        }
        // Loops over the frequency select boxes
        for(let i = 0; i < freqs.length; i++){
            // Add a change listener onto the frequency select boxes
            freqs[i].addEventListener('change',function(){
                // Set the session storage to the one that's been changed
                sessionStorage.setItem('freq',freqs[i].value);
                window.GAUtil.selectSubscriptionPlan();
            })
        }

        // Add an event listener onto step 3s button
        checkout.addEventListener('click',function(){
            // If the button doesn't contain a disabled class
            if(!checkout.classList.contains('disabled')) {
                // Create a cart array for the data
                let cartDataArray = [];
                let baseProducts = document.querySelectorAll('.real-product');
                // Set the data attributes to the variant ID - We can't do this as we need to find out the variant ID first
                baseProducts[0].dataset.variantId = getSelectedEyeVariantId("left");
                sessionStorage.setItem('leftVariantId',baseProducts[0].dataset.variantId);
                baseProducts[1].dataset.variantId = getSelectedEyeVariantId("right");
                sessionStorage.setItem('rightVariantId',baseProducts[1].dataset.variantId);

                // Get the date?
                let setid = getSetId();
                for (let i = 0; i < baseProducts.length; i++) {
                    // Build up an object for the data
                    let dataObject = {};
                    // Quantity will always be one in this case now
                    dataObject["quantity"] = 1;
                    // Get the variant IDs
                    dataObject["id"] = parseInt(baseProducts[i].dataset.variantId);
                    let finalPlan;
                    let oneMonthFrequencies = {
                        1: 0,
                        2: 1,
                        3: 2,
                        6: 3
                    };
                    let threeMonthFrequencies = {
                        3: 0,
                        6: 1
                    };
                    let sixMonthFrequencies = {
                        6: 0,
                        12: 1
                    };


                    // If it's the SILK product set the selling plan object up with the frequency
                    if(sessionStorage.productHandle === 'daysoft-silk-1month'){
                        finalPlan = sellingPlan['daysoft-silk-1month'][oneMonthFrequencies[sessionStorage.freq]].id;
                    }
                    // If it's the SILK product set the selling plan object up with the frequency
                    else if(sessionStorage.productHandle === 'daysoft-silk-3month'){
                        finalPlan = sellingPlan['daysoft-silk-3month'][threeMonthFrequencies[sessionStorage.freq]].id;
                    }
                    // If it's the SILK product set the selling plan object up with the frequency
                    else if(sessionStorage.productHandle === 'daysoft-silk-6month'){
                        finalPlan = sellingPlan['daysoft-silk-6month'][sixMonthFrequencies[sessionStorage.freq]].id;
                    }
                    // If it's the CLASSIC product set the selling plan object up with the frequency
                    else if(sessionStorage.productHandle === 'daysoft-classic-1month'){
                        finalPlan = sellingPlan['daysoft-classic-1month'][oneMonthFrequencies[sessionStorage.freq]].id;
                    }
                    // If it's the CLASSIC product set the selling plan object up with the frequency
                    else if(sessionStorage.productHandle === 'daysoft-classic-3month'){
                        finalPlan = sellingPlan['daysoft-classic-3month'][threeMonthFrequencies[sessionStorage.freq]].id;
                    }
                    // If it's the CLASSIC product set the selling plan object up with the frequency
                    else if(sessionStorage.productHandle === 'daysoft-classic-6month'){
                        finalPlan = sellingPlan['daysoft-classic-6month'][sixMonthFrequencies[sessionStorage.freq]].id;
                    }

                    // Put it into the newly created object
                    dataObject["selling_plan"] = finalPlan;
                    // Add the left and right eye properties in, set the subscription to 1 as it's a subscription and not a one time purchase, set the date it was added

                    dataObject["properties"] = {
                        eye: `${i === 0 ? 'left' : 'right'}`,
                        __setid: setid,
                        __subscription: 1
                    }

                    // Put the product object to the cart array
                    cartDataArray.push(dataObject);
                }

                // Put the cart array into an object
                let formData = {
                    items: cartDataArray,
                }

                // If the cart count is equal to 0
                if(cartCount === 0) {
                    checkout.classList.add('disabled');
                    checkout.addEventListener('click',function(){
                        cartPopup.classList.add('active');
                        cartPopupOverlay.classList.remove('hidden');
                        document.body.style.overflow = "hidden";
                        let cartPopupClose = cartPopup.querySelector('.close-button');
                        cartPopupClose.addEventListener('click',function(){
                            cartPopup.classList.remove('active');
                            cartPopupOverlay.classList.add('hidden');
                            document.body.removeAttribute("style");
                        })
                    })
                    localStorage.setItem('freq',sessionStorage.freq);
                    // If the local storage doesn't have a subscription item
                    if(localStorage.hasSubscriptionItem !== '1') {
                        // Fetch the script and post the product info to the cart by stringifying it into JSON
                        fetch("/cart/add.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(formData),
                        })
                            .then((response) => {
                                return response.json();
                            })
                            .then((response) => {
                                localStorage.setItem('hasSubscriptionItem', '1');
                                localStorage.setItem('formData', JSON.stringify(formData));
                                // This is whether you are logged in or not, you need to be logged in to buy a subscription
                                if (checkout.classList.contains('step-cart')) {
                                    window.location.replace("/cart");
                                    //If you're not logged in it will take you to the account register page
                                } else {
                                    window.location.replace('/account/register?_cart-subscription');
                                }
                            })
                            .catch((error) => {
                                console.error("Error:", error);
                            });
                    }
                    // Take the user to the register page if the subscription item local storage hasn't been set - only gets set when there's a response sent
                    else{
                        window.location.replace('/account/register?_cart-subscription');
                    }

                    // Add one - Should only ever be one product in the cart
                    cartCount++;
                }
            }
            window.GAUtil.subAddToCart();
        })
    }
}

/**
 * Extracts the selected product ID from local storage and the power for 
 * the eye that has been requested, looping over the productData array to find a 
 * matching product, and then looping over that products variants to find the one
 * with the matching lens power.  This function then returns the variant ID
 *  
 * @param   string      eye     The eye we want to get the variant ID for ("right", "left")
 * 
 * @return  integer             The variant ID       
 */
    function getSelectedEyeVariantId (eye) {

    // Get the selected product ID from local storage and set it to a variable called selectedProductId
    var selectedProductId = localStorage.productID;

    // Get the power for the eye that has been requested and put it in a variable called selectedPower
    var selectedPower = null;
    if(eye === "right"){
        selectedPower = sessionStorage.rightVariantVal;
    } else {
        selectedPower = sessionStorage.leftVariantVal;
    }

    // Create a new variable called variantId and set it to null
    var variantId = null;

    // Loop over the product Data array
    for(var i = 0; i < productData.length; i++){
        // Set a variable for the currentProduct
        var currentProduct = productData[i];

       
        // If the currentProduct.id does not match the selectedProductId, continue
        if(currentProduct.productId != selectedProductId){
            continue;
        }

        // Loop over the currentProduct variants
        for(var x = 0; x < currentProduct.lensPowers.length; x++) {
            // Set a variable for the currentVariant
        
            var currentVariant = currentProduct.lensPowers[x];

            // If the currentVariant.power does not match the selected lens power, continue
            if(currentVariant.option1 != selectedPower){
                continue;
            }
            // At this point, we have found a matching product/power, therefore this is the variant we want.  Set the variantId to the currentVariant.id
            variantId = currentVariant.id;
            // Break out of the loop
            break;
        }

        if(variantId != null){
            break;
        }
    }

    // Return the variantId
    return variantId;

}

stepJs();
window.addEventListener('load',stepJs)
document.addEventListener('DOMContentLoaded',stepJs);